import { createApp } from 'vue'
import VueLazyLoad from 'vue3-lazyload'
import App from './App.vue'
import router from './router'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import store from './store'
import { initializeTranslations } from './services/translationService'

// Initialize translation service
initializeTranslations()

// Transparent 1x1 placeholder shown while/if a thumbnail can't load. Keeps the
// console clean (log:false) instead of vue3-lazyload throwing "Image failed to
// load!" for every item whose image isn't reachable.
const BLANK_PX =
  'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='

createApp(App)
  .use(VueLazyLoad, {
    log: false,
    error: BLANK_PX,
    loading: BLANK_PX,
  })
  .use(store)
  .use(router)
  .mount('#app')

